import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import { Typography } from '@raisin/components-lib';

export const Container = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '100%',
  maxWidth: 520,

  [theme.breakpoints.down('lg')]: {
    minWidth: '100%',
    marginTop: theme.spacing(12),
  },
}));

export const ProductContent = styled('div')(({ theme }) => ({
  width: '100%',
  background: theme.palette.white.main,
  border: `1px solid ${theme.palette.black20.main}`,
  borderRadius: 6,

  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 440,
    padding: theme.spacing(2.5, 4),
    border: `1px solid ${theme.palette.black20.main}`,
    borderRadius: 6,
  },
}));

export const ProductDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(9),
  justifyContent: 'space-between',
  width: '100%',
  padding: theme.spacing(2.5, 9),
  borderRadius: 6,

  [theme.breakpoints.down('lg')]: {
    gap: theme.spacing(2.5, 8),
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 0,
  },
}));

export const ProductTopContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.25, 4.5, 1.25, 3.25),
  marginLeft: theme.spacing(3.5),
  color: theme.palette.black80.main,
  backgroundColor: theme.palette.blue10.main,
  borderRadius: '4px 4px 0 0',
}));

export const ProductTopText = styled(Typography)({
  color: 'inherit',
});

export const Row = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const ProductItem = styled('div')(({ theme, $isLongText }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'none' : 'block',

    '&:last-child': {
      marginLeft: 'auto',
    },
  },
}));

export const ProductItemRow = styled('div')(({ theme, $isLongText }) => ({
  display: 'none',

  [theme.breakpoints.down('lg')]: {
    display: $isLongText ? 'block' : 'none',
    margin: theme.spacing(2, 0, 3),
  },
}));

export const RowTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.25),
  fontWeight: theme.typography.subtitle2.fontWeight,
  color: theme.palette.black60.main,
}));

export const RowData = styled(Typography)(({ theme }) => ({
  maxWidth: 127,
  overflow: 'hidden',
  fontWeight: theme.typography.subtitle1.fontWeight,
  color: theme.palette.black80.main,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const ProductTypeChip = styled(MuiChip)(({ theme }) => ({
  width: 'fit-content',
  padding: theme.spacing(1, 2),
  fontSize: theme.typography.subtitle2.fontSize,
  fontWeight: theme.typography.subtitle2.fontWeight,
  color: theme.palette.white.main,
  textAlign: 'center',
  backgroundColor: theme.palette?.['noticeAccount100'].main,
  borderRadius: 4,

  '&.overnight': {
    backgroundColor: theme.palette?.['overnightMoney100'].main,
  },

  '&.term': {
    backgroundColor: theme.palette?.['fixedTerm100'].main,
  },
}));
